// context.ts
import { createContext } from "react";
import { IResult } from "ua-parser-js";
import { GameData } from "~/types/game";
import { AppLevelModalType } from "~/types/general";

export interface AppContextType {
  openAppLevelModal: (modal: AppLevelModalType) => void;
  appLevelModal: AppLevelModalType;
  userAgentInfo: IResult | null;
  hideBottomNavBar: boolean;
  setHideBottomNavBar: (hide: boolean) => void;
  setShowPWAInstallPrompt: (show: boolean) => void;
  gameData: GameData | null;
  setGameData: React.Dispatch<React.SetStateAction<GameData | null>>;
  isGameLoaded: boolean;
  setIsGameLoaded: (loaded: boolean) => void;
}
export const AppContext = createContext<AppContextType>({
  openAppLevelModal: () => {},
  appLevelModal: AppLevelModalType.CreateAccountForFree,
  userAgentInfo: null,
  hideBottomNavBar: false,
  setHideBottomNavBar: () => {},
  setShowPWAInstallPrompt: () => {},
  gameData: null,
  setGameData: () => {},
  isGameLoaded: false,
  setIsGameLoaded: () => {},
});
